import { Box, Typography } from '@material-ui/core'

import { useAppSelector } from 'store'

import { PremiumWrapper } from '../components/PremiumPreview/PremiumWrapper'
import DataPointsGrid from './DataPointsGrid'
import { HighschoolData } from './useGetHighschoolPreviewData'

const PostSecondaryEnrollmentDetails = ({ highschool }: { highschool: HighschoolData }) => {
  const isPremiumExplorerEnabled = useAppSelector(
    (state) => state.college.record?.Features?.SupportsPremiumHighSchoolExplorer || false,
  )
  if (!highschool) return null
  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap={16}
    >
      <Typography variant="h6">Post-Secondary Enrollment</Typography>
      <PremiumWrapper
        enabled={isPremiumExplorerEnabled}
        trackingIdPlacement="post-secondary-details"
        variant="small"
      >
        <DataPointsGrid
          dataPoints={[
            {
              title: '% Enrolling in 4-Year Colleges',
              data: highschool.pctAttendFourYearCollegeStudents
                ? `${highschool.pctAttendFourYearCollegeStudents}%`
                : undefined,
              isPremium: true,
            },
            {
              title: '% Enrolling in 2-Year Colleges',
              data: highschool.pctAttendTwoYearCollegeStudents
                ? `${highschool.pctAttendTwoYearCollegeStudents}%`
                : undefined,
              isPremium: true,
            },
          ]}
        />
      </PremiumWrapper>
    </Box>
  )
}

export default PostSecondaryEnrollmentDetails
